module.exports = __webpack_public_path__ + "images/stickers/taco-trophy.3a9dacbbcf2c9f5116b4.png";